var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShorttext01 = function SvgIconShorttext01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_shorttext-01_svg2__a",
    x1: -18.09,
    x2: 59.54,
    y1: 31.36,
    y2: 1.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_shorttext-01_svg2__a",
    id: "icon_shorttext-01_svg2__b",
    x1: -9.94,
    x2: 67.68,
    y1: 52.4,
    y2: 22.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_shorttext-01_svg2__a",
    id: "icon_shorttext-01_svg2__c",
    x1: 2.11,
    x2: 79.73,
    y1: 83.54,
    y2: 53.49
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_shorttext-01_svg2__a",
    id: "icon_shorttext-01_svg2__d",
    x1: 10.26,
    x2: 87.88,
    y1: 104.58,
    y2: 74.53
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M5 10h90c2.76 0 5-2.24 5-5s-2.24-5-5-5H5C2.24 0 0 2.24 0 5s2.24 5 5 5",
    style: {
      fill: "url(#icon_shorttext-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 40h60c2.76 0 5-2.24 5-5s-2.24-5-5-5H5c-2.76 0-5 2.24-5 5s2.24 5 5 5",
    style: {
      fill: "url(#icon_shorttext-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 60H5c-2.76 0-5 2.24-5 5s2.24 5 5 5h90c2.76 0 5-2.24 5-5s-2.24-5-5-5",
    style: {
      fill: "url(#icon_shorttext-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 90H5c-2.76 0-5 2.24-5 5s2.24 5 5 5h60c2.76 0 5-2.24 5-5s-2.24-5-5-5",
    style: {
      fill: "url(#icon_shorttext-01_svg2__d)"
    }
  }));
};
export default SvgIconShorttext01;